module.exports = __webpack_public_path__ + "static/media/44_A.ff863f75.png";